import { LinkTo } from '@ember/routing';
import Tile from '../tile';
import Svg from 'tio-employee/components/svg';
import { t } from 'ember-intl';

<template>
  <LinkTo @route="authenticated.repaying-student-debt.repayment-strategy-finder">
    <Tile @headerText={{t "common.strategy_finder.default"}}>
      <:description>
        {{t "dashboard_tiles.find_best_strategy"}}
      </:description>
      <:image>
        <Svg
          @name="marketing-strategy"
          width="100%"
          height="100%"
          role="img"
          aria-label={{t "svg.marketing_strategy"}}
        />
      </:image>
    </Tile>
  </LinkTo>
</template>
